import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "../components/ui/button";

export const NotFound = () => (
  <main className="min-h-screen bg-slate-50 py-24 md:py-32" data-testid="not-found-page">
    <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <div className="rounded-lg border border-slate-200 bg-white p-8 shadow-sm md:p-12">
        <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-[#E07000]">
          404
        </p>
        <h1 className="font-heading mb-4 text-3xl font-bold text-[#122A5C] md:text-4xl">
          Seite nicht gefunden
        </h1>
        <p className="mb-8 max-w-2xl text-lg leading-relaxed text-slate-600">
          Die angefragte Seite existiert nicht oder wurde verschoben.
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link to="/">
            <Button className="w-full rounded-full bg-[#E07000] px-7 py-5 font-semibold text-white hover:bg-[#C56200] sm:w-auto">
              <Home className="mr-2 h-5 w-5" />
              Zur Startseite
            </Button>
          </Link>
          <Link to="/ratgeber">
            <Button
              variant="outline"
              className="w-full rounded-full border-2 border-[#122A5C] px-7 py-5 font-semibold text-[#122A5C] hover:bg-[#122A5C] hover:text-white sm:w-auto"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Zum Ratgeber
            </Button>
          </Link>
        </div>
      </div>
    </div>
  </main>
);
